import React from 'react';
import StatusBadge from './StatusBadge';

function valueClass(value, emphasis = false) {
  const numericLike = /[\d₹%]/.test(value || '');
  if (emphasis) {
    return numericLike ? 'mono-cell font-semibold text-slate-900' : 'font-semibold text-slate-900';
  }
  return numericLike ? 'mono-cell' : '';
}

function renderCellContent(cell) {
  if (typeof cell === 'string') {
    return <span className={valueClass(cell)}>{cell}</span>;
  }

  const badge = cell.badge ? (
    cell.badgeKind === 'score' ? (
      <span
        data-coo="table-badge"
        data-coo-kind={cell.badgeKind}
        data-coo-tone={cell.tone}
        className="inline-flex rounded-lg border border-slate-200 bg-slate-50 px-2 py-1 text-[10px] font-semibold tracking-[0.03em] text-slate-700"
      >
        {cell.badge}
      </span>
    ) : (
      <StatusBadge tone={cell.tone} kind={cell.badgeKind}>
        {cell.badge}
      </StatusBadge>
    )
  ) : null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {cell.value ? (
        <span className={valueClass(cell.value, cell.emphasis)}>
          {cell.value}
        </span>
      ) : null}
      {badge}
    </div>
  );
}

export default function MetricTable({ table }) {
  return (
    <div className="table-scroll-shell">
      <table data-coo="metric-table" className="evidence-table min-w-full">
        <thead>
          <tr>
            {table.columns.map((column) => (
              <th key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={`${rowIndex}-${cellIndex}`}
                  colSpan={typeof cell === 'object' && cell.colSpan ? cell.colSpan : undefined}
                  className={`align-top ${rowIndex === table.rows.length - 1 ? 'border-b-0' : ''}`}
                >
                  {renderCellContent(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
